module.exports = __webpack_public_path__ + "static/media/Roboto-Light.b0f48bce.woff";